var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSave(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16.5H.533A.533.533 0 010 15.967V1.033A.533.533 0 01.533.5H11.2a.533.533 0 01.379.155l3.2 3.2a.533.533 0 01.154.378v11.734a.533.533 0 01-.533.533zM1.067 15.433h12.8V4.452L10.98 1.567H1.067v13.866z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 4.767H4.267a.533.533 0 01-.534-.534v-3.2A.533.533 0 014.267.5H9.6a.533.533 0 01.533.533v3.2a.533.533 0 01-.533.534zM4.8 3.7h4.267V1.567H4.8V3.7zM11.2 13.3H3.733a.533.533 0 01-.533-.533V7.433a.533.533 0 01.533-.533H11.2a.533.533 0 01.533.533v5.334a.533.533 0 01-.533.533zm-6.933-1.067h6.4V7.967h-6.4v4.266z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconSave.a144df19.svg";
export { MemoForwardRef as ReactComponent };